import React, { useEffect, useMemo } from "react";
import { useSession } from "../../../authentications/SessionContext";

const Pagination = ({
  ListViewData,
  indexOfFirstItem,
  indexOfLastItem,
  currentPage,
  PAGINATION_DEFAULT_LIMIT,
  handleChangePage,
  totalDataLength,
}) => {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  useEffect(() => {
    const container = document.querySelector(".pagination-icons");
    const activeButton = container.querySelector("button.active");

    if (container && activeButton) {
      // Check if active button is fully visible
      const containerRect = container.getBoundingClientRect();
      const activeRect = activeButton.getBoundingClientRect();

      if (
        activeRect.right > containerRect.right ||
        activeRect.left < containerRect.left
      ) {
        // Scroll the container to bring the active button into view
        container.scrollLeft = activeButton.offsetLeft - container.offsetLeft;
      }
    }
    // const activeButton = document.querySelector("button.active");
    // if (activeButton) {
    //   activeButton.scrollIntoView({
    //     behavior: "smooth",
    //     block: "nearest",
    //     inline: "start",
    //   });
    // }
  });

  const totalPaginationCount = useMemo(() => {
    if (typeof totalDataLength === "number") {
      return Math.ceil(totalDataLength / PAGINATION_DEFAULT_LIMIT);
    }
    return 1;
  }, [totalDataLength]);
  // console.log(
  //   "totalPaginationCount,totalDataLength",
  //   totalPaginationCount,
  //   totalDataLength
  // );
  return (
    <div className="pagination-container">
      {/* Pagination Info */}
      <div className="pagination-info">
        {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, totalDataLength)} of{" "}
        {totalDataLength} items
      </div>
      {/* Pagination Controls */}
      <div
        className={`${
          isVTEX ? "pagination-controls isVTEX" : "pagination-controls"
        }`}
      >
        <button
          onClick={() => handleChangePage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &lt;
        </button>
        {/* Page Numbers */}
        <div className="pagination-icons">
          {(() => {
            const pageNumbers = [];
            const totalPages = totalPaginationCount;
            const maxVisiblePages = 20; // Maximum number of visible buttons

            // Ensure the selected page starts at the beginning of the visible range
            const startPage = Math.max(
              1,
              Math.min(currentPage, totalPages - maxVisiblePages + 1)
            );
            const endPage = Math.min(
              totalPages,
              startPage + maxVisiblePages - 1
            );

            // Generate the page numbers for the visible range
            for (let i = startPage; i <= endPage; i++) {
              pageNumbers.push(i);
            }

            return pageNumbers.map((pageNumber) => (
              <button
                key={pageNumber}
                className={
                  currentPage === pageNumber
                    ? isVTEX
                      ? "isVTEX active"
                      : "active"
                    : ""
                }
                onClick={() => handleChangePage(pageNumber)}
              >
                {pageNumber}
              </button>
            ));
          })()}
        </div>

        {/* <div className="pagination-icons">
          {Array.from(
            { length: totalPaginationCount },
            (_, i) => i + 1 // Generate page numbers starting from 1
          ).map((pageNumber) => (
            <button
              key={pageNumber}
              className={
                currentPage === pageNumber
                  ? isVTEX
                    ? "isVTEX active"
                    : "active"
                  : ""
              }
              onClick={() => handleChangePage(pageNumber)}
            >
              {pageNumber}
            </button>
          ))}
        </div> */}
        <button
          onClick={() => handleChangePage(currentPage + 1)}
          disabled={
            currentPage ===
            Math.ceil(totalDataLength / PAGINATION_DEFAULT_LIMIT)
          }
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
